module.exports = __webpack_public_path__ + "whatsapp-icon1-8dce646d5b12e5e5a78d.svg";